import { Experience } from '../types/Experience'

export const mockExperiences: Experience[] = [
  // A. Vita quotidiana / casa
  {
    id: 'a1',
    name: 'Vino da pasto',
    bottleCount: 15,
    locked: true, // Changed to test suggested wines
    category: 'Vita quotidiana',
    icon: 'UtensilsCrossed',
    description:
      'Vini semplici e versatili che accompagnano i pasti quotidiani senza essere protagonisti.',
    wineDescription:
      "Per i pasti quotidiani sono ideali vini rossi leggeri e freschi come Chianti, Montepulciano d'Abruzzo o Valpolicella, oppure bianchi versatili come Vermentino o Verdicchio. Vini che non sovrastano il cibo ma lo accompagnano con equilibrio.",
    wineTags: ['Rosso leggero', 'Bianco fresco', 'Versatile'],
  },
  {
    id: 'a2',
    name: 'Bicchiere della buonanotte',
    bottleCount: 8,
    locked: false,
    category: 'Vita quotidiana',
    icon: 'Moon',
    description: 'Un calice serale per chiudere la giornata in relax.',
    wineDescription:
      'Per un momento di relax serale, scegli vini morbidi e avvolgenti: rossi maturi come Amarone o Primitivo, oppure passiti dolci come Recioto o Passito di Pantelleria. Vini da meditazione che accompagnano il riposo.',
  },
  {
    id: 'a3',
    name: 'Cena in famiglia',
    bottleCount: 12,
    locked: true, // Changed to test suggested wines
    category: 'Vita quotidiana',
    icon: 'Home',
    description: 'Momenti conviviali con i propri cari.',
    wineDescription:
      "Per le cene in famiglia servono vini che piacciono a tutti: rossi morbidi e fruttati come Primitivo o Nero d'Avola, bianchi aromatici come Vermentino, o bollicine come Prosecco per brindare insieme.",
  },
  {
    id: 'a4',
    name: 'Pranzo della domenica',
    bottleCount: 10,
    locked: false,
    category: 'Vita quotidiana',
    icon: 'CalendarDays',
    description: 'Il pranzo tradizionale domenicale.',
    wineDescription:
      'Il pranzo domenicale richiede vini strutturati ma eleganti: Barolo, Brunello o Chianti Classico Riserva per i primi piatti importanti, oppure bianchi di corpo come Gavi o Soave Classico.',
  },
  {
    id: 'a5',
    name: 'Pizza & vino',
    bottleCount: 14,
    locked: true, // Changed to test suggested wines
    category: 'Vita quotidiana',
    icon: 'Pizza',
    description: "L'abbinamento perfetto per una serata informale.",
    wineDescription:
      "Con la pizza servono vini giovani e beverini: rossi leggeri come Chianti o Valpolicella, rosati freschi come Cerasuolo d'Abruzzo, o bianchi vivaci come Vermentino. Vini che puliscono il palato e accompagnano ogni morso.",
  },
  {
    id: 'a6',
    name: 'Serata film',
    bottleCount: 9,
    locked: false,
    category: 'Vita quotidiana',
    icon: 'Film',
    description: 'Un buon vino per accompagnare il cinema a casa.',
    wineDescription:
      'Per una serata film scegli vini piacevoli e non impegnativi: rossi morbidi come Merlot o Primitivo, bianchi aromatici, o bollicine come Prosecco. Vini che si bevono facilmente mentre ci si rilassa.',
  },
  {
    id: 'a7',
    name: 'Vino mentre si cucina',
    bottleCount: 7,
    locked: false,
    category: 'Vita quotidiana',
    icon: 'ChefHat',
    description: 'Un bicchiere in compagnia mentre si prepara la cena.',
    wineDescription:
      'Mentre cucini, opta per vini freschi e leggeri: bianchi come Pinot Grigio o Vermentino, rosati, o rossi giovani. Vini che si possono sorseggiare senza impegno mentre si è ai fornelli.',
  },

  // B. Cene e momenti romantici
  {
    id: 'b1',
    name: 'Cena romantica',
    bottleCount: 6,
    locked: false,
    category: 'Romantico',
    icon: 'Heart',
    description: 'Una serata speciale a due.',
    wineDescription:
      'Per una cena romantica servono vini eleganti e raffinati: Amarone, Barolo o Brunello per i rossi, Franciacorta o Champagne per le bollicine. Vini che creano atmosfera e celebrano il momento.',
  },
  {
    id: 'b2',
    name: 'Anniversario',
    bottleCount: 4,
    locked: false,
    category: 'Romantico',
    icon: 'Sparkles',
    description: 'Celebrare i momenti importanti insieme.',
    wineDescription:
      'Gli anniversari meritano vini speciali: grandi rossi da invecchiamento come Barolo Riserva o Brunello, oppure bollicine di prestigio come Franciacorta Satèn o Champagne Vintage.',
  },
  {
    id: 'b3',
    name: 'Proposta di matrimonio',
    bottleCount: 0,
    locked: true,
    category: 'Romantico',
    icon: 'HeartHandshake',
    description: 'Il momento più importante.',
    wineDescription:
      'Per una proposta di matrimonio scegli solo il meglio: Champagne di grande prestigio, Franciacorta Riserva, o grandi rossi iconici come Sassicaia o Tignanello. Vini che rendono il momento indimenticabile.',
  },
  {
    id: 'b4',
    name: 'Vino sul divano',
    bottleCount: 8,
    locked: false,
    category: 'Romantico',
    icon: 'Sofa',
  },

  // C. Socialità informale
  {
    id: 'c1',
    name: 'Cena fra amici',
    bottleCount: 18,
    locked: false,
    category: 'Sociale',
    icon: 'Users',
  },
  {
    id: 'c2',
    name: 'Aperitivo tra amici',
    bottleCount: 11,
    locked: false,
    category: 'Sociale',
    icon: 'Martini',
  },
  {
    id: 'c3',
    name: 'Apericena',
    bottleCount: 9,
    locked: false,
    category: 'Sociale',
    icon: 'CookingPot',
  },
  {
    id: 'c4',
    name: 'Grigliata',
    bottleCount: 13,
    locked: false,
    category: 'Sociale',
    icon: 'Flame',
  },
  {
    id: 'c5',
    name: 'Picnic',
    bottleCount: 5,
    locked: false,
    category: 'Sociale',
    icon: 'Trees',
  },
  {
    id: 'c6',
    name: 'Festa in casa',
    bottleCount: 10,
    locked: false,
    category: 'Sociale',
    icon: 'PartyPopper',
  },
  {
    id: 'c7',
    name: 'Serata giochi',
    bottleCount: 7,
    locked: false,
    category: 'Sociale',
    icon: 'Gamepad2',
  },

  // D. Feste e celebrazioni
  {
    id: 'd1',
    name: 'Compleanno',
    bottleCount: 8,
    locked: false,
    category: 'Celebrazione',
    icon: 'Cake',
  },
  {
    id: 'd2',
    name: 'Capodanno',
    bottleCount: 0,
    locked: true,
    category: 'Celebrazione',
    icon: 'Sparkle',
  },
  {
    id: 'd3',
    name: 'Natale',
    bottleCount: 0,
    locked: true,
    category: 'Celebrazione',
    icon: 'Gift',
  },
  {
    id: 'd4',
    name: 'Pasqua',
    bottleCount: 0,
    locked: true,
    category: 'Celebrazione',
    icon: 'Egg',
  },
  {
    id: 'd5',
    name: 'Laurea',
    bottleCount: 3,
    locked: false,
    category: 'Celebrazione',
    icon: 'GraduationCap',
  },
  {
    id: 'd6',
    name: 'Matrimonio',
    bottleCount: 0,
    locked: true,
    category: 'Celebrazione',
    icon: 'Church',
  },
  {
    id: 'd7',
    name: 'Brindisi di benvenuto',
    bottleCount: 6,
    locked: false,
    category: 'Celebrazione',
    icon: 'HandHeart',
  },

  // E. Lavoro, networking e formalità
  {
    id: 'e1',
    name: 'Cena di lavoro',
    bottleCount: 0,
    locked: true,
    category: 'Lavoro',
    icon: 'Briefcase',
  },
  {
    id: 'e2',
    name: 'Pranzo di lavoro',
    bottleCount: 0,
    locked: true,
    category: 'Lavoro',
    icon: 'Coffee',
  },
  {
    id: 'e3',
    name: 'Networking',
    bottleCount: 0,
    locked: true,
    category: 'Lavoro',
    icon: 'Network',
  },
  {
    id: 'e4',
    name: 'Cena di rappresentanza',
    bottleCount: 0,
    locked: true,
    category: 'Lavoro',
    icon: 'Building2',
  },
  {
    id: 'e5',
    name: 'Regalo aziendale',
    bottleCount: 2,
    locked: false,
    category: 'Lavoro',
    icon: 'Package',
  },

  // F. Esperienze legate al mondo del vino
  {
    id: 'f1',
    name: 'Wine tasting',
    bottleCount: 4,
    locked: false,
    category: 'Degustazione',
    icon: 'Wine',
  },
  {
    id: 'f2',
    name: 'Degustazione in cantina',
    bottleCount: 0,
    locked: true,
    category: 'Degustazione',
    icon: 'Warehouse',
  },
  {
    id: 'f3',
    name: 'Enoturismo',
    bottleCount: 0,
    locked: true,
    category: 'Degustazione',
    icon: 'MapPin',
  },
  {
    id: 'f4',
    name: 'Degustazione verticale',
    bottleCount: 0,
    locked: true,
    category: 'Degustazione',
    icon: 'ArrowDownUp',
  },
  {
    id: 'f5',
    name: 'Degustazione orizzontale',
    bottleCount: 0,
    locked: true,
    category: 'Degustazione',
    icon: 'ArrowLeftRight',
  },
  {
    id: 'f6',
    name: 'Degustazione alla cieca',
    bottleCount: 3,
    locked: false,
    category: 'Degustazione',
    icon: 'EyeOff',
  },
  {
    id: 'f7',
    name: 'Corso di vino',
    bottleCount: 0,
    locked: true,
    category: 'Degustazione',
    icon: 'BookOpen',
  },
  {
    id: 'f8',
    name: 'Masterclass',
    bottleCount: 0,
    locked: true,
    category: 'Degustazione',
    icon: 'Award',
  },
  {
    id: 'f9',
    name: 'Salone del vino',
    bottleCount: 0,
    locked: true,
    category: 'Degustazione',
    icon: 'Store',
  },

  // G. Momenti personali e di umore
  {
    id: 'g1',
    name: 'Vino da meditazione',
    bottleCount: 2,
    locked: false,
    category: 'Personale',
    icon: 'Brain',
  },
  {
    id: 'g2',
    name: 'Vino da lettura',
    bottleCount: 5,
    locked: false,
    category: 'Personale',
    icon: 'Book',
  },
  {
    id: 'g3',
    name: 'Serata di pioggia',
    bottleCount: 6,
    locked: false,
    category: 'Personale',
    icon: 'CloudRain',
  },
  {
    id: 'g4',
    name: 'Vino estivo',
    bottleCount: 12,
    locked: false,
    category: 'Personale',
    icon: 'Sun',
  },
  {
    id: 'g5',
    name: 'Vino da spiaggia',
    bottleCount: 8,
    locked: false,
    category: 'Personale',
    icon: 'Waves',
  },
  {
    id: 'g6',
    name: 'Dopo cena',
    bottleCount: 4,
    locked: false,
    category: 'Personale',
    icon: 'Dessert',
  },
  {
    id: 'g7',
    name: 'Vino con sigaro',
    bottleCount: 0,
    locked: true,
    category: 'Personale',
    icon: 'Cigarette',
  },

  // H. Regalo, immagine e status
  {
    id: 'h1',
    name: 'Regalo di ringraziamento',
    bottleCount: 5,
    locked: false,
    category: 'Regalo',
    icon: 'Gift',
  },
  {
    id: 'h2',
    name: 'Vino da collezione',
    bottleCount: 0,
    locked: true,
    category: 'Regalo',
    icon: 'Archive',
  },
  {
    id: 'h3',
    name: 'Bottiglia iconica',
    bottleCount: 0,
    locked: true,
    category: 'Regalo',
    icon: 'Star',
  },
  {
    id: 'h4',
    name: 'Fare bella figura',
    bottleCount: 3,
    locked: false,
    category: 'Regalo',
    icon: 'Crown',
  },

  // I. Outdoor, viaggio e contesti speciali
  {
    id: 'i1',
    name: 'Giornata in barca',
    bottleCount: 0,
    locked: true,
    category: 'Outdoor',
    icon: 'Ship',
  },
  {
    id: 'i2',
    name: 'Aperitivo in vigneto',
    bottleCount: 0,
    locked: true,
    category: 'Outdoor',
    icon: 'Grape',
  },
  {
    id: 'i3',
    name: 'Street food',
    bottleCount: 4,
    locked: false,
    category: 'Outdoor',
    icon: 'Truck',
  },
  {
    id: 'i4',
    name: 'Brunch',
    bottleCount: 0,
    locked: true,
    category: 'Outdoor',
    icon: 'Croissant',
  },
]
